module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer",
    on: {
      "click": _vm.toggleExpand
    }
  }, [_c('div', [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("MIN/MAX SETTINGS")]), _vm._v(" "), (_vm.selectedPrincingType) ? _c('span', {
    staticClass: "fs-small dark bold ml-2"
  }, [_vm._v("(Only available in prices per person)")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "ico mx-0 fs-normal",
    class: {
      'ico-arrow-top': _vm.group.rulesExpanded,
      'ico-arrow-bottom': !_vm.group.rulesExpanded
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panelHolder",
    class: {
      closed: !_vm.group.rulesExpanded
    }
  }, [
    [_c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
      staticClass: "py-2 ml-3"
    }, [_c('label', [_vm._v("Participants (PAX) rules\n                                    "), (_vm.validateRulesPaxBook) ? _c('span', {
      staticClass: "color-6 fs-smaller ml-2"
    }, [_vm._v("Maximum value must be greater than minimum value")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "d-flex mt-3"
    }, [_c('div', {
      staticClass: "d-flex align-items-center mr-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.minimumPaxPerBooking),
        expression: "minimumPaxPerBooking"
      }],
      class: {
        'pointer': !_vm.disabled,
        'notAllowed': _vm.disabled || _vm.selectedPrincingType
      },
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.disabled || _vm.selectedPrincingType
      },
      domProps: {
        "value": (_vm.minimumPaxPerBooking)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.minimumPaxPerBooking = $event.target.value
        }, _vm.minBookingUpdate]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "w-100 ml-2"
    }, [_vm._v("Minimun")])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.maximumPaxPerBooking),
        expression: "maximumPaxPerBooking"
      }],
      class: {
        'pointer': !_vm.disabled,
        'notAllowed': _vm.disabled || _vm.selectedPrincingType
      },
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.disabled || _vm.selectedPrincingType
      },
      domProps: {
        "value": (_vm.maximumPaxPerBooking)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.maximumPaxPerBooking = $event.target.value
        }, _vm.maxBookingUpdate]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "w-100 ml-2"
    }, [_vm._v("Maximum")])])])]), _vm._v(" "), _c('div', {
      staticClass: "py-1 ml-3 radios"
    }, [(_vm.group.minimumPaxPerBooking > 0 || _vm.group.maximumPaxPerBooking > 0) ? _c('div', [_c('span', {
      staticClass: "fs-small"
    }, [_vm._v("If the participants' rules are not fulfilled:")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex justify-content-between mt-2",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('radio', {
      attrs: {
        "value": true,
        "disabled": _vm.disabled || _vm.selectedPrincingType
      },
      on: {
        "input": function($event) {
          return _vm.productAcivateUpdateFlag('minMaxRules')
        }
      },
      model: {
        value: (_vm.group.rejectBookingBasedOnMinMax),
        callback: function($$v) {
          _vm.$set(_vm.group, "rejectBookingBasedOnMinMax", $$v)
        },
        expression: "group.rejectBookingBasedOnMinMax"
      }
    }, [_vm._v("\n                                            Block bookings\n                                        ")]), _vm._v(" "), _c('radio', {
      attrs: {
        "value": false,
        "disabled": _vm.disabled || _vm.selectedPrincingType
      },
      on: {
        "input": function($event) {
          return _vm.productAcivateUpdateFlag('minMaxRules')
        }
      },
      model: {
        value: (_vm.group.rejectBookingBasedOnMinMax),
        callback: function($$v) {
          _vm.$set(_vm.group, "rejectBookingBasedOnMinMax", $$v)
        },
        expression: "group.rejectBookingBasedOnMinMax"
      }
    }, [_vm._v("\n                                            Pending to confirm\n                                        ")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
      staticClass: "py-2 ml-3"
    }, [_c('label', [_vm._v("Participants (PAX) rules\n                                    "), (_vm.validateRulesPaxEvent) ? _c('span', {
      staticClass: "color-6 fs-smaller ml-2"
    }, [_vm._v("Value must be between minimum and maximum")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_vm._m(2), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.minimumLotation),
        expression: "minimumLotation"
      }],
      class: {
        'pointer': !_vm.disabled,
        'notAllowed': _vm.disabled || _vm.selectedPrincingType
      },
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.disabled || _vm.selectedPrincingType
      },
      domProps: {
        "value": (_vm.minimumLotation)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.minimumLotation = $event.target.value
        }, _vm.lotationEventUpdate]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "w-100 ml-2"
    }, [_vm._v("Minimun")])])])])])])])])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lighter border-bottom-light border-top-light py-2"
  }, [_c('span', {
    staticClass: "bold dark pl-3"
  }, [_vm._v("Booking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lighter border-bottom-light border-top-light py-2"
  }, [_c('span', {
    staticClass: "bold dark pl-3"
  }, [_vm._v("Event")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-2"
  }, [_c('span', {
    staticClass: "fs-small"
  }, [_vm._v("If a minimum PAX per event is set, bookings are pending until this minimum is reached ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e85d8218"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/MinMaxManager.vue
// module id = 1508
// module chunks = 0